import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Tooltip from '@material-ui/core/Tooltip'
import PropTypes from 'prop-types'

const styles = () => ({
  tooltip: {
    fontSize: '14px'
  }
})

const ToolTipWrapper = props => (
  <Tooltip title={props.title} classes={{ tooltip: props.classes.tooltip }} {...props}>
    {props.children}
  </Tooltip>
)

ToolTipWrapper.propTypes = {
  children: PropTypes.object,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  classes: PropTypes.object
}

export default withStyles(styles)(ToolTipWrapper)
